export default function XQuery_Example() {
  return (
    <div>
      <h1>XQuery_Example</h1>
      <p>This is the XQuery_Example component.</p>
    </div>
  );
}